import { render, staticRenderFns } from "./ads-complain.vue?vue&type=template&id=0afa70f0&"
import script from "./ads-complain.vue?vue&type=script&lang=js&"
export * from "./ads-complain.vue?vue&type=script&lang=js&"
import style0 from "./ads-complain.vue?vue&type=style&index=0&id=0afa70f0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports